import { render } from "./ApplicationView.vue?vue&type=template&id=7ad36c2c&scoped=true"
import script from "./ApplicationView.vue?vue&type=script&lang=js"
export * from "./ApplicationView.vue?vue&type=script&lang=js"

import "./ApplicationView.vue?vue&type=style&index=0&id=7ad36c2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad36c2c"]])

export default __exports__